// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Y7Uw","disabled":"FileBtn_disabled__2-YV-","warn":"FileBtn_warn__2M_nc","fade":"FileBtn_fade__QRRu3"};